import {
  BuildingComplex,
  CarFront,
  CircleDollarSign,
  Cpu,
  Gavel,
  LayoutDashboard,
  Radio,
  Settings2,
  Users,
  Wrench,
} from 'lucide-react';

/** @public */
export const primaryNavigation = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
    description: 'KPI flotta, costi e criticità operative',
    matchPaths: ['/dashboard'],
  },
  {
    id: 'operations',
    label: 'Flotta Live',
    path: '/operations',
    icon: Radio,
    description: 'Controllo realtime, mappa live e stato operativo flotta',
    matchPaths: ['/operations'],
  },
  {
    id: 'vehicles',
    label: 'Veicoli',
    path: '/vehicles',
    icon: CarFront,
    description: 'Lifecycle, tracking, documenti e costi dei mezzi',
    matchPaths: ['/vehicles'],
  },
  {
    id: 'drivers',
    label: 'Conducenti',
    path: '/drivers',
    icon: Users,
    description: 'Assegnazioni, documenti, città e posizione stimata',
    matchPaths: ['/drivers'],
  },
  {
    id: 'maintenance',
    label: 'Manutenzioni',
    path: '/maintenance',
    icon: Wrench,
    description: 'Pianificazione, officine e interventi aperti',
    matchPaths: ['/maintenance'],
  },
  {
    id: 'fleetExpenses',
    label: 'Carburante',
    path: '/fleet-expenses',
    icon: CircleDollarSign,
    description: 'Spesa mensile, carte e analisi rifornimenti',
    matchPaths: ['/fleet-expenses', '/fuel-cards'],
  },
  {
    id: 'fines',
    label: 'Multe',
    path: '/fines',
    icon: Gavel,
    description: 'Attribuzione, gestione pratica e pagamento',
    matchPaths: ['/fines'],
  },
  {
    id: 'workshops',
    label: 'Officine',
    path: '/workshops',
    icon: BuildingComplex,
    description: 'Officine e interventi aperti',
    matchPaths: ['/workshops'],
  },
  {
    id: 'settings',
    label: 'Impostazioni',
    path: '/settings',
    icon: Settings2,
    description: 'Il tuo account e le sezioni di amministrazione',
    matchPaths: ['/settings'],
  },
];

// Voci singole della sezione "Sistema", ognuna mostrata solo se l'ability la consente.
const systemNavigation = [
  {
    id: 'users',
    label: 'Utenti',
    path: '/users',
    icon: Users,
    description: 'Gestione utenti e ruoli',
    can: ['read', 'User'],
  },
  {
    id: 'devices',
    label: 'Dispositivi',
    path: '/devices',
    icon: Cpu,
    description: 'Dispositivi GPS e loro assegnazione ai veicoli',
    can: ['read', 'Device'],
  },
  {
    id: 'tenants',
    label: 'Tenant',
    path: '/tenants',
    icon: BuildingComplex,
    description: 'Gestione tenant e configurazione multi-tenant',
    can: ['read', 'Tenant'],
  },
];

export function getNavigationSections(ability) {
  const sections = [{ id: 'primary', items: primaryNavigation }];

  const systemItems = systemNavigation.filter((item) => ability.can(...item.can));
  if (systemItems.length > 0) {
    sections.push({ id: 'system', label: 'Sistema', items: systemItems });
  }

  return sections;
}

export function getVisibleNavigation(ability) {
  return getNavigationSections(ability).flatMap((section) => section.items);
}

export function isNavigationItemActive(pathname, item) {
  if (!pathname || !item) return false;
  if (item.path === '/') {
    return pathname === '/';
  }

  const matchers =
    Array.isArray(item.matchPaths) && item.matchPaths.length > 0 ? item.matchPaths : [item.path];

  return matchers.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
